export default "__VITE_ASSET__y5UI9SUv__"